import { DEFAULT_HIT_PADDING, type HitAreaOptions } from './HitArea';

/** Field values a {@link Clickable} can be built with. Omitted fields keep their default. */
export type ClickableOptions = HitAreaOptions;

/**
 * Marks an entity as something the pointer can press and click.
 *
 * Pure data: it says the entity is interactive and how forgiving its edges are, and nothing else. The
 * hit-testing is a system's job, and what a click *does* is a behavior's, which is why there is no
 * callback here.
 *
 * The hit area is the entity's {@link SpriteRenderer} quad grown by {@link Clickable.padding}. An
 * entity with no sprite has nothing to hit and is skipped.
 */
export class Clickable {
  /** Whether the entity responds to the pointer. A disabled clickable is invisible to hit-testing. */
  enabled: boolean;
  /** Extra world units of hit area on every side, for targets smaller than a toddler's fingertip. */
  padding: number;

  constructor(options: ClickableOptions = {}) {
    this.enabled = options.enabled ?? true;
    this.padding = options.padding ?? DEFAULT_HIT_PADDING;
  }
}
